module.exports = __webpack_public_path__ + "abf56cfdc3e318f59a53d015d4442188.png";